export default "/fonts/lato-light-webfont.eot?b6a5c8d350d64289ec6103383ad94c3e";